export default {
  webLive_single_viewing: 'Single viewer',
  webLive_many_viewing: 'Multiple viewers',
  webLive_scanned_code: 'Number of people who have scanned the code: {length}',
  webLive_zhiniao_scan: 'Smart Learn App - Scan',
  webLive_start_live: 'Start watching live',
  webLive_select_view: 'Please select watching mode',
  webLive_start_live: 'Start watching live',
  webLive_address: 'Address:',
  webLive_telephone: 'Phone:',
  webLive_please_ID: 'Please enter the live room and live room command',
  webLive_shibboleth_rules: 'The command of the live room is combined with alphanumeric characters',
  webLive_portal_watch: 'Smart Portal only supports viewing, please login Smart Learn on PC side',
  webLive_studio_ID: 'Live room ID:',
  webLive_enter_ID: 'Please enter',
  webLive_live_password: 'Live command:',
  webLive_enter_password: 'Please enter',
  webLive_password_Room: 'Enter',
  webLive_portal_live03: '03Web-Smart portal live',
  webLive_show_list03: '0301Web-Display live list',
  webLive_check_live0302: '0302Web-View live',
  webLive_studio_fulled: 'Live room is full',
  webLive_select_failed: 'Query failed, please try again later',
  webLive_noreplay: 'No replay yet',
  webLive_noLive: 'No live yet',
  webLive_chat: 'Chat',
  webLive_new_message: "You've got a new message",
  webLive_failed_video: 'Network error. Failed to get video. Please check your network and try again',
  webLive_error_get_data: 'Get data error, please try again later',
  webLive_data_wrong: 'There is an error in the data',
  webLive_last_one: 'This is the last one~',
  webLive_guangdong: 'Guangdong',
  webLive_shenzhen: 'Shenzhen',
  webLive_nanshan: 'Nanshan District',
  webLive_studio_deleted: 'The live room has been deleted',
  webLive_vr_app: 'Please watch the VR live in Smart Learn App',
  webLive_without_power: 'You have no permission to enter',
  webLive_go_app_learn: 'The live room has enabled proctoring, please learn in Smart Learn App',
  webLive_current_broadcast: 'Current live: {liveStatusName}',
  webLive_broadcast_paid: 'This is a paid live, please login to Smart Learn and pay to watch',
  webLive_live_pages08: '08Web-Live room page',
  webLive_show_pages0801: '0801Web-Display live room page',
  webLive_tourist: 'Visitor',
  webLive_unlock: 'Enable',
  webLive_switch_video: 'Toggle videos',
  webLive_hide_window: 'Hide small window',
  webLive_show_window: 'Display small window',
  webLive_public_announcement: 'Announcement',
  webLive_anchor_head_sculpture: 'Host avatar',
  webLive_studio_anchor: 'Anchor: ',
  webLive_audience: 'Audience:',
  webLive_check_out: 'Punch out',
  webLive_check_in: 'Sign-in',
  webLive_focus_on_watch: 'Watching',
  webLive_scan_code: 'Scan the code',
  webLive_calculatew_time: '{flag} start counting watching time after {panelText}',
  webLive_left_scan: 'Smart Learn App - Scan on the top left corner',
  webLive_scanede_num: 'Number of people who have scanned the code: {userList.length }',
  webLive_playback_deleted: 'The replay has been deleted',
  webLive_playback_ended: 'The replay has ended',
  webLive_not_send_empty: 'Please do not send empty messages',
  webLive_send_interactive0803: '0803Web-Send interaction',
  webLive_send_message: 'Send a message',
  webLive_studio_forbidden_speak: 'All members have been muted in the live room',
  webLive_speak: "Let's interact with the anchor",
  webLive_send_bntn: 'Post',
  webLive_play_error: "If you can't watch the live replay video, please toggle your browser to the latest version and log in to watch." ,
  webLive_not_support_hls: 'hls is unavailable on the current browser',
  webLive_Esc_quit: 'Press Esc or double click to exit full screen',
  webLive_shrink: 'Zoom out',
  webLive_click_zoom0802: '0802Web-Click to zoom',
  webLive_lianmai: 'Mic interaction',
  webLive_no_lianmai: 'No mic interaction',
  webLive_voice_playing: 'Audio playing',
  webLive_failed_get_playback: 'Network error. Failed to get the live replay. Please check your network and try again',
  webLive_zhiniao_school: 'Smart Learn | School',
  webLive_anchor_out: 'The anchor is absent now',
  webLive_play_btn: 'Play button',
  webLive_volume: 'Volume',
  webLive_full_screen: 'Full screen',
  webLive_enlarge: 'Zoom in',
  webLive_got_it: 'OK',
  webLive_version_too_low: 'Your browser version is out-dated, please upgrade your browser first.' ,
  webLive_will_quit_learning: 'The end time of training program falls. You are about to quit learning',
  webLive_failed_punch_in: 'Punching failed',
  webLive_validation_failed: 'Verification failed',
  webLive_code_no_exit: 'QR code address does not exist!' ,
  webLive_upload: 'Download to local',
  webLive_count_time: "OK ({countTime})",
  webLive_stop: 'Stop',
  webLive_start: 'Start',
  webLive_pay: 'It is a paid live, please turn to app',
  webLive_live: 'Live',
  webLive_course: 'Courses',
  webLive_card_status:'Study card {status}',
  webLive_payed_course:'Purchased Courses'

}
